import { render, staticRenderFns } from "./GalaxyAutobuyerBox.vue?vue&type=template&id=bad9c542&scoped=true&"
import script from "./GalaxyAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./GalaxyAutobuyerBox.vue?vue&type=script&lang=js&"
import style0 from "./GalaxyAutobuyerBox.vue?vue&type=style&index=0&id=bad9c542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad9c542",
  null
  
)

export default component.exports